module.exports = require("core-js/library/fn/array/from");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs2/core-js/array/from.js
// module id = 75
// module chunks = 0 1